import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { rootCssSet } from "../../utils/helpers/common";

const initialState = {
  sendInviteDialog: false,
  agencyFilterDialog: false,
  listReset: false,
  paymentInfoFilter: false,
  paymentInfoListReset: false,
  agencyEditReset:false
};

export const agencySlice = createSlice({
  name: "agency",
  initialState,
  reducers: {
    setInviteDialog: (state) => {
      state.sendInviteDialog = !state.sendInviteDialog;
    },

    setAgencyFilterDialog: (state) => {
      state.agencyFilterDialog = !state.agencyFilterDialog;
      rootCssSet();
    },
    setPaymentInfoFilter: (state) => {
      state.paymentInfoFilter = !state.paymentInfoFilter;
    },

    setPaymentInfoListReset: (state) => {
      state.paymentInfoListReset = !state.paymentInfoListReset;
    },

    setListReset: (state) => {
      state.listReset = !state.listReset;
    },

    setAgencyEditReset: (state) => {
      state.agencyEditReset = !state.agencyEditReset;
    },
  },
});

export const agencyAction = agencySlice.actions;
export const agencyReducer = agencySlice.reducer;
